export default "__VITE_ASSET__0gJi8ki0__"